module.exports = __webpack_public_path__ + "static/racism_spanish-29be5088d11ca7cc67255c255231ea63.png";